/**
 * Equal-weight combination of Classic / Novel Fundamental (Z-score) indicators.
 * Import-free of engine to avoid circular bundles.
 */

export const CLASSIC_NOVEL_COMBO_KEY = "cnf_combo";

/** Members of the "Classic / Novel Fundamental" category (Z-score valuation metrics). */
export const CLASSIC_NOVEL_FUNDAMENTAL_KEYS = [
  "div_yield_z",
  "pb_ratio",
  "pe_ratio",
  "poi_ratio",
  "ps_ratio",
  "cf_price",
  "ev_ebitda_z",
];

/**
 * Yield-style Z-scores are high when "cheap" (e.g. EV/EBITDA yield Z > 1 = buy);
 * price-multiple Z-scores are low when cheap (e.g. P/E Z < -1 = buy).
 * Flip yields before averaging so the combo uses one polarity: low = cheap, high = expensive.
 */
export const COMBO_FLIP_SIGN_KEYS = ["div_yield_z", "ev_ebitda_z"];

export const COMBO_MEMBERS_STORAGE_KEY = "indicatorClassicNovelComboMembers";

export function isClassicNovelCombo(key) {
  return key === CLASSIC_NOVEL_COMBO_KEY;
}

export function normalizeComboMembers(members) {
  const allowed = new Set(CLASSIC_NOVEL_FUNDAMENTAL_KEYS);
  const list = Array.isArray(members) ? members : [];
  const out = [];
  const seen = new Set();
  for (const k of list) {
    if (!allowed.has(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  return out.length ? out : [...CLASSIC_NOVEL_FUNDAMENTAL_KEYS];
}

export function loadComboMembers() {
  try {
    const raw = localStorage.getItem(COMBO_MEMBERS_STORAGE_KEY);
    if (!raw) return [...CLASSIC_NOVEL_FUNDAMENTAL_KEYS];
    const parsed = JSON.parse(raw);
    return normalizeComboMembers(parsed);
  } catch {
    return [...CLASSIC_NOVEL_FUNDAMENTAL_KEYS];
  }
}

export function saveComboMembers(members) {
  const next = normalizeComboMembers(members);
  try {
    localStorage.setItem(COMBO_MEMBERS_STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function getComboIndicatorLabel(members) {
  const n = normalizeComboMembers(members).length;
  return `Combined Classic/Novel (${n} equal-weight)`;
}

export function shouldFlipComboMember(key) {
  return COMBO_FLIP_SIGN_KEYS.includes(key);
}
